import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ATV from "@/components/ATV-screen";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Startseite',
    component: Home
  },
  {
    path: '/atv',
    name: 'ATV',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: ATV
  }
]

const router = new VueRouter({
  routes
})

export default router
